import * as React from 'react';
import { IconArrowUpRight16, ArticleHeading0, ArticleHeading5 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IBuilderLinkBlockProps {
  count: number;
  url: string;
  housesText: string;
  newbuildingText: string;
}

export function BuilderLinkBlock({ count, url, housesText, newbuildingText }: IBuilderLinkBlockProps) {
  const [hovered, setHovered] = React.useState(false);

  const changeHovered = React.useCallback(() => setHovered(!hovered), [hovered]);

  const color = hovered ? 'primary_100' : 'black_100';

  return (
    <a
      className={styles['link']}
      href={url}
      target="blank"
      rel="noreferrer"
      onMouseOver={changeHovered}
      onMouseOut={changeHovered}
    >
      <ArticleHeading0 color={color}>{count}</ArticleHeading0>
      <div className={styles['statistic-item-text']}>
        <ArticleHeading5 as="h5" color={color}>
          {housesText}
          <br />
          {newbuildingText}
          <div className={styles['arrow']}>
            <IconArrowUpRight16 color="primary_100" />
          </div>
        </ArticleHeading5>
      </div>
    </a>
  );
}
